import Tool from './tags/Tool';

function Tools() {
  return (
    <div>
      <Tool />                  
    </div>
  );
}

export default Tools;
